import React from 'react';

/**
 * Der Vorgang, auf dessen Seite der Chat gerade offen ist — oder `null`
 * (#1336). Das Widget liest ihn aus der Adresse; Karten fragen danach, ob sie
 * dort etwas ablegen sollen.
 */
export const KiVorgangContext = React.createContext<number | null>(null);

/** `/legaltransaction/123`, `/order_book/123`, `/archive/123` → 123. */
export const vorgangAusPfad = (pfad: string): number | null => {
  const treffer =
    /^\/(?:legaltransaction|order_book|archive)\/(\d+)(?:\/|$)/.exec(pfad);
  return treffer ? Number(treffer[1]) : null;
};
